'use client';

import React, { useState, useEffect } from 'react';


interface CalculatorInputs {
  monthlyCallVolume: number;
  avgCallDuration: number;
  agentHourlyCost: number;
}

const ROICalculator = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [inputs, setInputs] = useState<CalculatorInputs>({
    monthlyCallVolume: 10000,
    avgCallDuration: 8,
    agentHourlyCost: 25
  });

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const calculateROI = () => {
    const monthlyAgentHours = inputs.monthlyCallVolume * inputs.avgCallDuration / 60;
    const currentMonthlyCost = monthlyAgentHours * inputs.agentHourlyCost;
    const aiAutomationRate = 0.65;
    const monthlySavings = currentMonthlyCost * aiAutomationRate;
    const annualSavings = monthlySavings * 12;
    const implementationCost = 50000;
    const monthsToROI = Math.ceil(implementationCost / monthlySavings);

    return {
      currentMonthlyCost: Math.round(currentMonthlyCost),
      monthlySavings: Math.round(monthlySavings),
      annualSavings: Math.round(annualSavings),
      monthsToROI
    };
  };

  const roi = isHydrated ? calculateROI() : {
    currentMonthlyCost: 0,
    monthlySavings: 0,
    annualSavings: 0,
    monthsToROI: 0
  };

  const handleInputChange = (field: keyof CalculatorInputs, value: string) => {
    if (!isHydrated) return;
    const numValue = parseInt(value) || 0;
    setInputs((prev) => ({ ...prev, [field]: numValue }));
  };

  return;











































































































































};

export default ROICalculator;